import React, { Component } from 'react';
import { Scrollama, Step } from 'react-scrollama';
import { Icon, Tooltip } from 'antd';
import BeforeAfterBelgiumMap from '../charts/BeforeAfterBelgiumMap/BeforeAfterBelgiumMapComponent';
import BelgianData from './communeEvolution';
import TinyConsumptionEvolution from '../charts/TinyConsumptionEvolution/TinyConsumptionEvolutionComponent';
import TinyEvolutionChart from '../charts/TinyEvolutionChart/TinyEvolutionChartComponent';

const provinceData = [{"2010":{"province":"BE-WHT","year":"2010","mcMembers":296215,"opioid":30849,"oxycodoneOther":448,"opioidFullYear":null,"opioidRatio":0.104143949496143,"oxycodoneOtherRatio":0.0015124149688570802,"opioidFullYearRation":null},"2018":{"province":"BE-WHT","year":"2018","mcMembers":295209,"opioid":36485,"oxycodoneOther":2512,"opioidFullYear":null,"opioidRatio":0.12359040544156852,"oxycodoneOtherRatio":0.008509225667239143,"opioidFullYearRation":null},"fullName":"Hainaut"},{"2010":{"province":"BE-WLX","year":"2010","mcMembers":89718,"opioid":8871,"oxycodoneOther":62,"opioidFullYear":null,"opioidRatio":0.0988764796361934,"oxycodoneOtherRatio":0.0006910541920238971,"opioidFullYearRation":null},"2018":{"province":"BE-WLX","year":"2018","mcMembers":101862,"opioid":12118,"oxycodoneOther":534,"opioidFullYear":null,"opioidRatio":0.11896487404527695,"oxycodoneOtherRatio":0.005242386758555693,"opioidFullYearRation":null},"fullName":"Luxembourg"},{"2010":{"province":"BE-WNA","year":"2010","mcMembers":161598,"opioid":16658,"oxycodoneOther":314,"opioidFullYear":null,"opioidRatio":0.10308295894751172,"oxycodoneOtherRatio":0.001943093355115781,"opioidFullYearRation":null},"2018":{"province":"BE-WNA","year":"2018","mcMembers":166260,"opioid":19161,"oxycodoneOther":1415,"opioidFullYear":null,"opioidRatio":0.11524720317574882,"oxycodoneOtherRatio":0.008510766269698064,"opioidFullYearRation":null},"fullName":"Namur"},{"2010":{"province":"BE-WLG","year":"2010","mcMembers":270660,"opioid":24553,"oxycodoneOther":525,"opioidFullYear":null,"opioidRatio":0.09071528855390527,"oxycodoneOtherRatio":0.0019397029483484815,"opioidFullYearRation":null},"2018":{"province":"BE-WLG","year":"2018","mcMembers":277555,"opioid":30561,"oxycodoneOther":2625,"opioidFullYear":null,"opioidRatio":0.11010790654104592,"oxycodoneOtherRatio":0.009457584983156492,"opioidFullYearRation":null},"fullName":"Liège"},{"2010":{"province":"BE-WBR","year":"2010","mcMembers":86886,"opioid":6800,"oxycodoneOther":61,"opioidFullYear":null,"opioidRatio":0.07826347167552886,"oxycodoneOtherRatio":0.0007020693782657736,"opioidFullYearRation":null},"2018":{"province":"BE-WBR","year":"2018","mcMembers":98128,"opioid":9123,"oxycodoneOther":401,"opioidFullYear":null,"opioidRatio":0.0929704060003261,"oxycodoneOtherRatio":0.004086499266264471,"opioidFullYearRation":null},"fullName":"Brabant wallon"},{"2010":{"province":"BE-VLI","year":"2010","mcMembers":435022,"opioid":25056,"oxycodoneOther":607,"opioidFullYear":null,"opioidRatio":0.057597087043873646,"oxycodoneOtherRatio":0.0013953317303492696,"opioidFullYearRation":null},"2018":{"province":"BE-VLI","year":"2018","mcMembers":433771,"opioid":36682,"oxycodoneOther":2765,"opioidFullYear":null,"opioidRatio":0.08456535821896807,"oxycodoneOtherRatio":0.006374331156301366,"opioidFullYearRation":null},"fullName":"Limbourg"},{"2010":{"province":"BE-VWV","year":"2010","mcMembers":708342,"opioid":37628,"oxycodoneOther":981,"opioidFullYear":null,"opioidRatio":0.05312123239903888,"oxycodoneOtherRatio":0.001384924231515285,"opioidFullYearRation":null},"2018":{"province":"BE-VWV","year":"2018","mcMembers":714646,"opioid":56580,"oxycodoneOther":3294,"opioidFullYear":null,"opioidRatio":0.07917206561010626,"oxycodoneOtherRatio":0.0046092750816488165,"opioidFullYearRation":null},"fullName":"Flandre-Occidentale"},{"2010":{"province":null,"year":"2010","mcMembers":127044,"opioid":8800,"oxycodoneOther":54,"opioidFullYear":null,"opioidRatio":0.06926734044897831,"oxycodoneOtherRatio":0.0004250495891187305,"opioidFullYearRation":null},"2018":{"province":null,"year":"2018","mcMembers":138117,"opioid":10865,"oxycodoneOther":442,"opioidFullYear":null,"opioidRatio":0.07866518965804355,"oxycodoneOtherRatio":0.0032001853501017253,"opioidFullYearRation":null},"fullName":"Bruxelles"},{"2010":{"province":"BE-VOV","year":"2010","mcMembers":728161,"opioid":39552,"oxycodoneOther":890,"opioidFullYear":null,"opioidRatio":0.05431765777074026,"oxycodoneOtherRatio":0.001222257165654299,"opioidFullYearRation":null},"2018":{"province":"BE-VOV","year":"2018","mcMembers":740401,"opioid":56786,"oxycodoneOther":2898,"opioidFullYear":null,"opioidRatio":0.07669627674733016,"oxycodoneOtherRatio":0.003914095199763372,"opioidFullYearRation":null},"fullName":"Flandre-Orientale"},{"2010":{"province":"BE-VAN","year":"2010","mcMembers":779311,"opioid":40073,"oxycodoneOther":737,"opioidFullYear":null,"opioidRatio":0.05142106296459308,"oxycodoneOtherRatio":0.0009457071695382203,"opioidFullYearRation":null},"2018":{"province":"BE-VAN","year":"2018","mcMembers":777025,"opioid":58904,"oxycodoneOther":2657,"opioidFullYear":null,"opioidRatio":0.07580708471413404,"oxycodoneOtherRatio":0.0034194523985714743,"opioidFullYearRation":null},"fullName":"Anvers"},{"2010":{"province":"BE-VBR","year":"2010","mcMembers":488019,"opioid":26753,"oxycodoneOther":361,"opioidFullYear":null,"opioidRatio":0.05481958694231167,"oxycodoneOtherRatio":0.000739725297580627,"opioidFullYearRation":null},"2018":{"province":"BE-VBR","year":"2018","mcMembers":513066,"opioid":38838,"oxycodoneOther":1976,"opioidFullYear":null,"opioidRatio":0.07569786343277474,"oxycodoneOtherRatio":0.0038513563557125204,"opioidFullYearRation":null},"fullName":"Brabant flamand"}];

const styles = {
  main: {
    //padding: '70vh 2vw',
    display: 'flex',
    fontFamily: 'Open Sans',
    justifyContent: 'space-between',
    position: 'relative',
  },
  /*test: {
    padding: 35,
    backgroundImage:
      `linear-gradient(to bottom,
        rgba(240, 255, 40, 1) 0%,
        rgba(240, 255, 40, 1) 100%),
      linear-gradient(to bottom,
        rgba(240, 40, 40, 1) 0%,
        rgba(240, 40, 40, 1) 100%)`,
    backgroundClip: 'content-box, padding-box',
  },*/
  btnContainer: {
    position: 'fixed',
  },
  btn: {
    padding: '8px 10px',
    fontSize: '14px',
    margin: '10px',
    fontFamily: 'Open Sans',
  },
  graphic: {
    //flexBasis: '100%',
    position: 'sticky',
    /*position: '-webkit-sticky',
    position: '-moz-sticky',
    position: '-ms-sticky',
    position: 'sticky',
    position: '-webkit-sticky',*/
    //width: '75%',
    //padding: '5rem 0',
    top: '0',
    //alignSelf: 'flex-end',
    marginLeft: '35%',
    width: '65%',
    //backgroundColor: '#aaa',
    paddingTop: '10vh',
    height: '80vh'
  },
  scroller: {
    pointerEvents: 'none',
    zIndex: 100,
    flexBasis: '35%',
  },
  step: {
    fontFamily: 'tex-gyre-schola', 
    fontSize: 18,
    lineHeight: '1.2',
    color: 'black',
    margin: '2rem 2rem 2rem 2rem',
    textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white',
    paddingTop: 200,
    paddingBottom: 200,
    //border: '1px solid #333',
    pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'career', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px',
    backgroundColor: '#ffffffc7'
  },
  quoted: {
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px',
    backgroundColor: '#ffffffc7'
  }
};

export default class BelgianSituation extends Component {
  constructor(props) {
    super(props);
    this.state = { step: 0, width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onStepEnter = ({ element, data, direction }) => {
    //element.style.backgroundColor = 'lightgoldenrodyellow';
    this.setState({ step: data, direction });
  };

  onStepExit = ({ element, data, direction }) => {
    if(this.state.step === 1 && direction === 'up' ) this.setState({ step: 0, direction });
    //element.style.backgroundColor = '#fff';
  };

  render() {
    const { step, height, width } = this.state;
    return (
      <div>
      <div>
        <div style={styles.main}>
          <div style={{ ...styles.scroller, flexBasis: width < 900 ? '100%' : '35%' }}>
            <Scrollama
              offset={0.33}
              onStepEnter={this.onStepEnter}
              onStepExit={this.onStepExit}
              //debug
            >
              <Step data={1}>
                  <div style={{...styles.step, minHeight: '100vh' }}>
                    <div style={styles.p}>
                      One in 10 Belgians has been prescribed opioids.
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>
                    In Belgium and based on INAMI figures (pharmacies open to the public), 1,169,000 people in Belgium took at least one dose of a Fentanyl (ex: Durogesic), Oxycodone (ex: Oxycontin) or Tramadol (ex: Contramal).<br/>
                    That’s an increase of 35%. If these painkillers are effective for cancer patients, they represent only… 8% of opioid consumers (based on data provided by <span style={{pointerEvents: 'auto'}}>
                        <Tooltip overlayStyle={{ width: 500}} title={<div style={{wordBreak: 'normal'}}>
                        <p>The statistical data presented for Belgium is based on all of the affiliates of the largest mutuality in Belgium, the Mutualités Chrétiennes, representing 4.5 million of the Belgian population. The sample is satisfactory …</p>
                        <p>However, this mutuality does not cover municipalities in the same way. More present in Flanders, it represents 51% of the population, it covers 14% of the Brussels population, and 26% of Wallonia, a number which is nonetheless significant for presenting statistical data.</p>
                      </div>} placement="bottom"><span><span style={{ fontWeight: 900}}>{' '}Mutualités Chrétiennes</span> <Icon type="question-circle" theme="twoTone" /></span></Tooltip></span>). The remaining 92% use opioids for the treatment of non-cancer pain (back pain, neuralgia, joint pain, fibromyalgia ...).<br/>
                    <br/>
                    <div>It is mainly general practitioners who prescribe these painkillers to non-cancer patients. Among the significant increases to be mentioned, tramadol (Contramal) which increased by + 40% between 2010 and 2018 and the powerful oxycodone (+ 292%). For the latter, marketing really started in 2010.</div>
                    </div>
                    {/*<div style={{...styles.quoted, paddingBottom: 16 }}>
                      La proportion de la population Belge consommant des opioides est passé de 6.4% à 8.6%, soit une augmentation de 35%. Celà repésente pas loin de 300.000 personnes en plus sur l'année. En 2018 on dénombrait approximativement 1 million de Belge ayant été prescrit un traitement à base d'opioïde.
                      Le plus inquiétant dans tout ça c'est que la proportion de la population qui a consommé des opioïdes sur une période de temps d'une année a pour la première fois dépassé 1%, c-à-d à peu près 120,000 personnes. 
                      people: 688428 -> 975893 
                      delat people 287465
                      <div>Bruxelles: +0.91% (7.04% -> 7.95%)</div>
                      <div>Wallonie: + 1.77% (9.71% -> 11.48%)</div>
                      <div>Flandre: +2.4% (5.39% -> 7.79%)</div>
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>
                      Ces données proviennent de la Mutualité Chrétienne. Les proportions de cosommation d'opioïdes sont celles des membres de la mutulaité (ceux-ci représente un proportion significative de la population Belge, à savoir 40%). Il est à noter que les chiffres relatifs aux proportions de la population Belge sont des extrapolations.
                    </div>*/}
                  </div>
                </Step>
                <Step data={2}>
                  <div style={{...styles.step, height: '100vh' }}>
                    <div style={styles.p}>
                      Disparities exist between the North and the South of the country.
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>In order to have a more precise view of the situation in terms of population, let us represent each of the municipalities by a circle whose area is proportional to its number of inhabitants.</div>
                  </div>
                </Step>
                <Step data={3}>
                  <div style={{...styles.step, minHeight: '100vh' }}>
                    <div style={styles.p}>
                      The provinces have a very different consumption profile.
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>It is in the Walloonian provinces that we observe the highest proportion of people consuming opioids in 2018. On the other hand, it is in the Flemish provinces that we observe the greatest increase compared to 2010.</div>
                    <div style={{...styles.quoted, paddingBottom: 16, fontFamily: 'Open Sans' }}>
                      { height && provinceData.map((province, i) => (
                        <div key={province.fullName} style={{marginBottom: 8}}>
                          <TinyEvolutionChart showLabel={i === 0} label={province.fullName} past={province["2010"].opioidRatio} now={province["2018"].opioidRatio} max={provinceData[0]["2018"].opioidRatio}/>
                        </div>
                      ))}
                    </div>
                  </div>
                </Step>
                <Step data={4}>
                  <div style={{...styles.step, height: '120vh' }}>
                    <div style={styles.p}>
                      Regional evolution.
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>
                      We observed a 45% increase in Flanders, 18% in Wallonia, 13% in Brussels.
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16, fontFamily: 'Open Sans' }}>
                      <div>
                        <div style={{ whiteSpace: 'nowrap', backgroundColor: "dodgerblue", textShadow: 'none', paddingLeft: 4, marginBottom: 4, width: '100%' }}><span style={{ color: 'white', mixBlendMode: 'screen' }}>Wallonie – 11.5% (2018)</span></div>
                      </div>
                      <div>
                        <div style={{ whiteSpace: 'nowrap', backgroundColor: "#FFB300", textShadow: 'none', paddingLeft: 4, marginBottom: 4, width: `${Math.round(7.9 / 11.5 * 100)}%` }}><span style={{ color: 'white', mixBlendMode: 'screen' }}>Bruxelles – 7.9% (2018)</span></div>
                      </div>
                      <div>
                        <div style={{ whiteSpace: 'nowrap', backgroundColor: "#E91E63", textShadow: 'none', paddingLeft: 4, marginBottom: 4, width: `${Math.round(7.8 / 11.5 * 100)}%` }}><span style={{ color: 'white', mixBlendMode: 'screen' }}>Flandre – 7.8% (2018)</span></div>
                      </div>
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>
                      {height && <TinyConsumptionEvolution />}
                    </div>
                  </div>
                </Step>
                <Step data={5}>
                  <div style={{...styles.step, height: '170vh' }}>
                    <div style={styles.p}>
                    What sort of relation exists between opioid use and unemployment? 
                    </div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>Numerous studies have investigated the supposed links between the high intake of opioids and the low participation of labor forces in certain American regions.</div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>We can justifiably wonder about the situation in Belgium: although we cannot conclude too quickly from cause and effect relationships, we have observed, however, a correlation between the ratio of the population consuming opioids and the unemployment rate of a municipality (especially in rural areas). This diagram shows a correlation between unemployment and opioid use. The more the "bubbles" go to the right (heavy usage of opioids), the more they take off (high unemployment). This correlation is not observed for Brussels (yellow bubbles), where despite high unemployment, opioid intake is low.</div>
                    <div style={{...styles.quoted, paddingBottom: 16 }}>Source: <span style={{pointerEvents: 'auto'}}><a target="_blank" rel="noopener noreferrer" href="https://www.iweps.be/indicateur-statistique/population-active-taux-dactivite-taux-demploi-taux-de-chomage-administratifs-commune/"> IWEPS activity structure of the Belgian population aged 20 to 64. Statistics for 2017.</a></span></div>
                  </div>
                </Step>
            </Scrollama>
          </div>
          <div style={{ position: 'absolute', top: 0, bottom: 0, width: '100%'}}>
            {/*<div style={styles.graphic}>*/}
            <div className="graphic" style={{ 
            marginLeft: width < 900 ? '0%' : '35%', 
            width: width < 900 ? '100%' : '65%',
            paddingTop: width < 900 ? '20vh' : '10vh',
            height: width < 900 ? '50vh' : '80vh',
            }}>
              {/*<div>Step: {step} – Direction: {direction} </div>*/}
              {height &&  <BeforeAfterBelgiumMap 
                  valueAccessor="opioidRatio"
                  valueName="Proportion of the non cancerous population consuming opioids"
                  thresholds={[0.06, 0.07, 0.08, 0.09, 0.10, 0.11, 0.12, 0.14, 0.16]}//{[0, 0.2, 0.4, 0.6, 0.9, 1.2, 1.6, 2.2]}
                  data={BelgianData}
                  starting={step === 1}
                  afterOnly={step >= 2}
                  communeShape={step >= 2 ? 'circle' : 'geoShape'}
                  provinceShape={step >= 3 ? 'circle' : 'geoShape'}
                  regionalView={step >= 4}
                  scatterplotView={step >= 5}
                />}
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BelgianSituation/BelgianSituation.js